const Types = {
  FETCH_TICKET_DISPENSER_LIST: "FETCH_TICKET_DISPENSER_LIST",
  FETCH_VALIDATION_LIST: "FETCH_VALIDATION_LIST",
  FETCH_PAYMENT_DOWNLOAD_DATA: "FETCH_PAYMENT_DOWNLOAD_DATA",
};

export default Types;
